import React from 'react';
import styled from 'styled-components';

import { mediaQueries } from 'shared/styles';
import { VisuallyHidden } from 'src/components/visually-hidden';
import { DutchieTwoDotZeroLogo } from 'src/svg/dutchie-two-dot-zero-logo';
import { StyledLogo } from './login.styles';

export const Summer25 = (): JSX.Element => (
  <Wrapper>
    <StyledLogo fill='#fff' />

    <Content>
      <DutchieTwoDotZeroLogo />
      <VisuallyHidden>Dutchie 2.0</VisuallyHidden>

      <Heading>Summer ‘25 Release</Heading>

      <Cta
        href='https://business.dutchie.com/summer25?utm_source=backoffice&utm_medium=banner&utm_campaign=summerreleasejun25'
        target='_blank'
        rel='noreferrer'
      >
        See what’s new
      </Cta>

      <Image
        src='https://images.dutchie.com/admin-login/summer-25/features.png'
        alt='Screenshots of new features'
        width={684}
      />
    </Content>
  </Wrapper>
);

const Wrapper = styled.div`
  align-items: center;
  background: #005943 url('https://images.dutchie.com/admin-login/summer-25/background.jpg') no-repeat center/cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 600px;
  max-width: 846px;
  width: 45%;

  @media ${mediaQueries.largeDesktop} {
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }
`;

const Content = styled.div`
  align-items: center;
  color: #fff7ef;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 148px 20px 20px;
`;

const Heading = styled.h1`
  background: linear-gradient(#ffffffcc, #ffffff80);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  font-size: 86px;
  font-weight: 700;
  line-height: 1;
  margin: 20px auto 32px;
  max-width: 518px;
  text-align: center;
  text-transform: uppercase;

  @media ${mediaQueries.belowMedium} {
    font-size: 48px;
  }
`;

const Cta = styled.a`
  background: #fff7ef;
  color: #005943;
  border-radius: 4px;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  line-height: ${20 / 16};
  padding: 11px 16px;
  transition: all 0.1s ease-in-out;

  &:hover {
    background: none;
    box-shadow: inset 0 0 0 2px #fff7ef;
    color: #fff7ef;
  }
`;

const Image = styled.img`
  display: block;
  margin: 64px auto 0;
  max-width: 100%;
`;
